import { FC } from 'react'

interface AttractionLinkProps {
  attraction: {
    label: string;
    path: string;
  }
}

export const AttractionLink: FC<AttractionLinkProps> = ({attraction}) => {
  return (
    <div className="mx-6 mb-2">
      <li key={attraction.label}>
        <a
          href={attraction.path}
          target="_blank"
          rel="noreferrer"
          className="block px-4 py-2 underline hover:text-primary-dark"
        >
          {attraction.label}
        </a>
      </li>
    </div>
  )
}